import script from "./PosReturnReceiptPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./PosReturnReceiptPrint.vue?vue&type=script&setup=true&lang=js"

import "./PosReturnReceiptPrint.vue?vue&type=style&index=0&id=a1ff5fba&lang=css"
import "./PosReturnReceiptPrint.vue?vue&type=style&index=1&id=a1ff5fba&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1ff5fba"]])

export default __exports__